export class FacturationActif
{
    eDataVoiceActif!: boolean
    eSellerActif!: boolean

    constructor(data?: Partial<FacturationActif>) {
        Object.assign(this, data)
    }

}